import { Duration } from "luxon";

import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";
import { IBFRecord } from "@/lib/drivers/insulet/IBFRecords/IBFRecord";

export type IBFTimeChange = {
  timeDifference: Duration;
};

export const IBF_TIME_CHANGE = {
  value: 0x0002,
  name: "IBF_TIME_CHANGE",
  size: 3,
  parse: (record: IBFRecord): IBFTimeChange => {
    const seconds = record.nextUInt8();
    const minutes = record.nextUInt8();
    const hours = record.nextUInt8();
    const timeDifference = Duration.fromObject({ hours, minutes, seconds });
    return { timeDifference };
  },
} satisfies IBFHistoryRecordDefinition<IBFTimeChange>;
